module.exports = __webpack_public_path__ + "img/3.c9e5fcd6.png";